"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeRecipe = void 0;
function executeRecipe({ map, resolver }) {
    return function (action) {
        return map.call(this, (x) => resolver(action(x), () => x));
    };
}
exports.executeRecipe = executeRecipe;
